/** @jsx jsx */

import React, { useContext, Fragment } from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext as _interactionContext } from './interactionContext';
import { getMultichoiceData } from 'services/scorm/scormService';

export const NewTick = ({ width = 9, height = 7, color }) => {
  // updated again. . .
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 8 8"
    >
      <g>
        <path
          style={{
            stroke: color,
            strokeWidth: 1.5,
            strokeMiterlimit: 10,
            fill: 'none',
          }}
          d="M.5,4.46l2.41,2L7.44,1.55"
        />
      </g>
    </svg>
  );
};

export const Tick = ({ type = 'radio', width = 11, height = 11, color }) => {
  return (
    <div
      css={css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 20,
        height: 20,
      })}
    >
      <NewTick color={color} />
    </div>
  );
};

export const Radio = props => {
  let {
    id,
    selected,
    updateSelected,
    correct,
    resolved,
    checkboxColor,
    style,
    isMulti,
    isSquare,
    //
    hasFocus,
  } = props;

  // contexts
  const interactionContext: any = useContext(_interactionContext);
  const { showCorrectAnswer, isMultichoiceMedia } = interactionContext.props;

  let savedMultichoiceData = getMultichoiceData();

  let lockedBySCORM;
  if (savedMultichoiceData && savedMultichoiceData[interactionContext.id]) {
    savedMultichoiceData = savedMultichoiceData[interactionContext.id];
    //
    selected = savedMultichoiceData.selected.includes(id);
    resolved = true;
    lockedBySCORM = true;
  }

  return (
    <Fragment>
      <div
        className="checkbox-radio"
        css={css`
          all: unset;
          position: relative;
          flex: 0 0 auto;
          width: 20px;
          height: 20px;
          ${!isMulti && !isSquare && 'border-radius: 50%;'}
          border: 1px solid ${checkboxColor};
          outline: ${checkboxColor};
          background: ${selected ? checkboxColor : 'transparent'};
          ${!!showCorrectAnswer &&
            resolved &&
            correct &&
            'background: transparent;'}

          // cursor: pointer;

          ${!(resolved || lockedBySCORM) &&
            `
          &:hover {
            opacity: 0.8;
            background: ${selected ? checkboxColor : 'transparent'};
          }

          &:focus {
            box-shadow: 0 0 0 2px ${checkboxColor};
            transition: box-shadow 0.2s;
            ${!isMultichoiceMedia && 'display: none;'}
          }
          `}

          // pointer-events: auto;

          ${(resolved || lockedBySCORM) &&
            `
            pointer-events: none !important;
            * {
              pointer-events: none !important;
            }
          `}

       
        `}
        style={style}
        onClick={
          window.dev()
            ? e => {
                e.stopPropagation();
                updateSelected(id);
              }
            : () => {}
        }
        // tabIndex={isMultichoiceMedia && 0}
        // aria-live="assertive"
      >
        {!!showCorrectAnswer && resolved && correct && (
          <div
            css={css`
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 100%;
            `}
          >
            <Tick
              type={isMulti || isSquare ? 'checkbox' : 'radio'}
              color={checkboxColor}
            />
          </div>
        )}

        {/* <div className="sr-only">{selected ? 'checked' : 'not checked'}</div> */}
      </div>
    </Fragment>
  );
};
